// Utility functions to extract custom fields from contact data
export const extractCustomFieldFromContact = (contact, fieldName) => {
  const customFields = contact?.customFields || [];
  
  // Field ID mappings for different locations (fallback approach)
  const fieldIdMappings = {
    pin: ['dgCqVzWZyjf9nBPZb1Fb', 'hGGYQhML7rKUfOy9zU1N'],
    last_checkin_date: ['DYHqTDrhxV2j0on5zREO', 'wOd0FiUmoKoc92u6s5Fk'],
    date_joined: ['jIOEli9lAyzaZriIPBSv', 'r7Yzr7tSs1KRfiFWmbHR'],
    belt_rank: ['j85mg6sDEatSgHmUHcph'],
    member_picture: ['jaEvRPpKS5dndwtaJFGh']
  };
  
  // Field key mappings
  const fieldKeyMappings = {
    pin: 'contact.pin',
    last_checkin_date: 'contact.last_checkin_date',
    date_joined: 'contact.date_joined',
    belt_rank: 'contact.belt__rank',
    member_picture: 'contact.member_picture'
  };
  
  // Try to find the field using multiple strategies
  const field = customFields.find(field => {
    const fieldId = field.id || '';
    const fieldKey = field.key || '';
    const fieldValue = field.value || '';
    
    // Strategy 1: Known field IDs for this field type
    if (fieldIdMappings[fieldName]?.includes(fieldId)) {
      return true;
    }
    
    // Strategy 2: Field key
    if (fieldKey === fieldKeyMappings[fieldName]) {
      return true;
    }
    
    // Strategy 3: Special pattern matching for PIN
    if (fieldName === 'pin' && fieldValue && 
        fieldValue.length === 6 && 
        /^[A-Z0-9]{6}$/.test(fieldValue)) {
      return true;
    }
    
    return false;
  });
  
  return field?.value || null;
};

// Utility function to extract PIN from contact custom fields
export const extractPinFromContact = (contact) => {
  return extractCustomFieldFromContact(contact, 'pin') || 'No PIN';
};

// Utility function to extract last check-in date from contact custom fields
export const extractLastCheckinFromContact = (contact) => {
  const lastCheckin = extractCustomFieldFromContact(contact, 'last_checkin_date');
  return lastCheckin || 'Never';
};

// Utility function to extract date joined from contact custom fields
export const extractDateJoinedFromContact = (contact) => {
  const dateJoined = extractCustomFieldFromContact(contact, 'date_joined');
  if (dateJoined) {
    // Handle timestamp format (convert to date string)
    if (dateJoined.toString().length === 13) {
      const date = new Date(parseInt(dateJoined));
      return date.toLocaleDateString();
    }
    return dateJoined;
  }
  return 'Unknown';
};

// Utility function to format contact for display
export const formatContactForDisplay = (contact) => {
  return {
    ...contact,
    pin: extractPinFromContact(contact),
    lastCheckin: extractLastCheckinFromContact(contact),
    dateJoined: extractDateJoinedFromContact(contact)
  };
};